export default {"src":"/_next/static/media/eau.adb90236.svg","height":73,"width":72,"blurWidth":0,"blurHeight":0};